import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Grid,
	Switch,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { blueGrey, orange } from '@mui/material/colors';
import { useSelector } from 'react-redux';
import {
	selectTerritories,
	selectRegions,
} from '../../../redux/territorySlice';
import { Box } from '@mui/system';
import FourthBranch from './FourthBranch';

export default function ThirdBranch({
	parent,
	branch,
	newRights,
	checkBoxChange,
	switchChange,
	determineSwitchStatus,
}) {
	const regions = useSelector(selectRegions(branch, parent));
	const territories = useSelector(selectTerritories(branch, parent));

	return (
		<Box>
			{territories && territories.length > 0 && (
				<Grid
					container
					sx={{ marginTop: 1, marginBottom: 2 }}
				>
					{regions && regions.length > 0 && (
						<Grid
							item
							xs={2}
							sx={{
								padding: 2,
								borderRadius: 2,
								textAlign: 'center',
							}}
						></Grid>
					)}
					<Grid
						item
						xs={regions && regions.length > 0 ? 10 : 12}
						sx={{
							backgroundColor:
								regions && regions.length > 0 ? blueGrey[800] : blueGrey[700],
							padding: 0,
							borderRadius: 1,
							textAlign: 'center',
						}}
					>
						{territories.map((territory) => (
							<FormControlLabel
								key={territory._id}
								control={
									<Checkbox
										name={territory.Name}
										checked={newRights.includes(territory.Name)}
										onChange={checkBoxChange}
										sx={{
											color: blueGrey[50],
											'&.Mui-checked': {
												color: orange[500],
											},
										}}
									/>
								}
								label={territory.Name}
								sx={{
									marginRight: 6,
									display: 'inline-block',
									color: blueGrey[50],
									// color: newRights.includes(territory.Name)
									// 	? orange[500]
									// 	: blueGrey[50],
									'&.Mui-checked': {
										color: orange[500],
									},
								}}
							/>
						))}
					</Grid>
				</Grid>
			)}
			{regions &&
				regions.length > 0 &&
				regions.map((region) => (
					<Grid
						key={region._id}
						container
					>
						<Grid
							item
							xs={2}
						>
							<FormGroup>
								<FormControlLabel
									control={
										<Switch
											onChange={(e) => switchChange(e, region.Branch)}
											checked={determineSwitchStatus(
												region.Name,
												region.Branch
											)}
											name={region.Name}
											sx={{
												'&.MuiSwitch-root .MuiSwitch-switchBase': {
													color: blueGrey[50],
												},

												'&.MuiSwitch-root .Mui-checked': {
													color: orange[500],
												},
											}}
										/>
									}
									label={region.Name}
								/>
							</FormGroup>
						</Grid>
						<Grid
							item
							xs={10}
							sx={{ marginBottom: 2 }}
						>
							<Accordion
								sx={{
									backgroundColor: blueGrey[800],
									color: blueGrey[50],
								}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon sx={{ color: blueGrey[50] }} />}
								></AccordionSummary>
								<AccordionDetails>
									<Box>
										<FourthBranch
											parent={region.Name}
											branch={region.Branch}
											newRights={newRights}
											checkBoxChange={checkBoxChange}
											switchChange={switchChange}
											determineSwitchStatus={determineSwitchStatus}
										/>
									</Box>
								</AccordionDetails>
							</Accordion>
						</Grid>
					</Grid>
				))}
		</Box>
	);
}
